<script setup lang="ts">
import { ref } from 'vue';
import { NxtInput, NxtTextEditor, NxtIconButton } from '@future-harry/nxt-styles';
import MediaSelector from '@/core/components/form-elements/MediaSelector.vue';
import LanguageTabs from '@/core/components/layout-elements/LanguageTabs.vue';

const model = defineModel<any>();

const props = defineProps<{
   errors: Record<string, string>;
}>();

const backgroundMode = ref<'image' | 'color'>('image');
</script>

<template>
   <LanguageTabs :errors="props.errors" v-slot="{ activeLanguageName }">
      <NxtTextEditor
         v-if="activeLanguageName"
         v-plain-text-paste
         :name="`title.${activeLanguageName}`"
         :key="`title.${activeLanguageName}`"
         :label="$t('live-editor.content-blocks.header.label_title')"
         :hidden-options="['align', 'font-size', 'list', 'emojis', 'reset-style', 'link']"
         :min-height="'auto'"
         :errors="props.errors"
         v-model="model.title[activeLanguageName]"
      />

      <NxtInput
         :label="$t('live-editor.content-blocks.header.label_text_color')"
         type="color"
         name="text_color"
         v-model="model.text_color"
      />

      <div class="header-bg-row">
         <label for="background" class="header-bg-label">{{ $t('live-editor.content-blocks.header.label_background') }}</label>
         <div class="header-bg-toggle">
            <NxtIconButton
               name="image"
               :disabled="backgroundMode === 'image'"
               :color="`var(--nxt-main)`"
               @click="backgroundMode = 'image'"
            />
            <NxtIconButton
               name="paint-roller"
               :disabled="backgroundMode === 'color'"
               :color="`var(--nxt-main)`"
               @click="backgroundMode = 'color'"
            />
         </div>
      </div>

      <div v-if="backgroundMode === 'image'">
         <MediaSelector v-model="model.background_image" v-model:media-id="model.background_id" />
      </div>
      <div v-else>
         <NxtInput type="color" name="background_color" v-model="model.background_color" />
      </div>
   </LanguageTabs>
</template>

<style scoped lang="scss">
.header-bg-row {
   display: flex;
   align-items: center;
   justify-content: space-between;

   label {
      font-weight: var(--nxt-font-bold);
      margin: 0;
   }
}

.header-bg-toggle {
   display: flex;
   align-items: center;
   justify-content: flex-end;

   .nxt-icon-button {
      background-color: var(--nxt-light-grey);

      &:first-child {
         border-top-right-radius: 0;
         border-bottom-right-radius: 0;
      }

      &:last-child {
         border-top-left-radius: 0;
         border-bottom-left-radius: 0;
      }

      &[disabled] {
         background-color: var(--nxt-main);

         :deep(.nxt-icon) {
            color: var(--nxt-white) !important;
         }
      }
   }
}
</style>
